!function(w, d) {

  var attr = 'data-youtube',
      a = d.querySelectorAll('a['+attr+']')

  for (var n = 0; n < a.length; n++) {
    a[n].onclick = loadVideo
  }

  function loadVideo(e) {

    if (w.matchMedia) {
      var mq = w.matchMedia('(min-width: 46.24em)')
      if(!mq.matches) return
    }

    e.preventDefault()

    var iframe = d.createElement('iframe')
    iframe.setAttribute('src', '//www.youtube.com/embed/' + this.getAttribute(attr) + '?rel=0&autoplay=1')
    iframe.setAttribute('frameborder', '0')

    if(null !== this.getAttribute('data-popup'))
    {
      var pop = d.createElement('div'),
          inn = pop.cloneNode(),
          vid = pop.cloneNode()

      vid.className = 'video'
      vid.appendChild(iframe)
      inn.className = 'popup-inner'
      inn.appendChild(vid)
      pop.className = 'popup fade'
      pop.appendChild(inn)
      setTimeout(function(){
        pop.className = 'popup'
      }, 1)

      pop.onclick = function(e) {
        var self = this
        self.className = 'popup fade'
        setTimeout(function(){
          self.parentNode.removeChild(self)
        }, 200)
      }

      d.body.appendChild(pop)
    }
    else
    {
      this.parentNode.replaceChild(iframe, this)
    }
  }

}(window, document)
